import {
    mapState,
    mapActions,
    mapGetters
  } from 'vuex'

export default {
  data () {
    return {
      yearList: null,
      isLoaded: false,
      priceOptions: [{
        value: 5000,
        text: '$5000'
      },
      {
        value: 10000,
        text: '$10000'
      },
      {
        value: 15000,
        text: '$15000'
      },
      {
        value: 20000,
        text: '$20000'
      },
      {
        value: 25000,
        text: '$25000'
      },
      {
        value: 30000,
        text: '$30000'
      },
      {
        value: 35000,
        text: '$35000'
      },
      {
        value: 40000,
        text: '$40000'
      },
      {
        value: 45000,
        text: '$45000'
      },
      {
        value: 50000,
        text: '$50000'
      },
      {
        value: 55000,
        text: '$55000'
      },
      {
        value: 60000,
        text: '$60000'
      },
      {
        value: 65000,
        text: '$65000'
      },
      {
        value: 70000,
        text: '$70000'
      },
      {
        value: 75000,
        text: '$75000'
      },
      {
        value: 80000,
        text: '$80000'
      },
      {
        value: 85000,
        text: '$85000'
      },
      {
        value: 90000,
        text: '$90000'
      },
      {
        value: 95000,
        text: '$95000'
      },
      {
        value: 100000,
        text: '$100000'
      }
      ]
    }
  },
  computed: {
    ...mapState({
      makesList: state => state.inventory.makes,
      modelsList: state => state.inventory.models,
      trimsList: state => state.inventory.trims,
      bodysList: state => state.inventory.bodys,
      customization: state => state.common.customization
    }),
    ...mapGetters({
      filtermodel: 'inventory/getFilterModel'
    }),
    borderStyle: function () {
      var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor : 'none'
      var backgroundStyle = this.customization.mainColor
      var colorStyle = this.customization.fontColor
      return {
        border: borderStyle,
        background: backgroundStyle,
        color: colorStyle
      }
    }
  },
  mounted: async function () {
    console.log(this.modelsList)
    if (this.filtermodel.make === null) {
      await this.loadMakes()
    }
    this.yearList = this.getYears()
    this.isLoaded = true
  },
  methods: {
    ...mapActions({
      loadMakes: 'inventory/loadMakes',
      loadModels: 'inventory/loadModels',
      loadTrims: 'inventory/loadTrims',
      updateFilter: 'inventory/updateFilter',
      updateFilterToDefault: 'inventory/updateFilterToDefault'
    }),
    async setMakes () {
      this.isLoaded = false
      console.log(this.filtermodel)
      this.filtermodel.model = null
      this.filtermodel.trim = null
      await this.updateFilter(this.filtermodel)
      await this.loadModels()
      this.isLoaded = true
    },
    async setModel () {
      this.isLoaded = false
      this.filtermodel.trim = null
      await this.updateFilter(this.filtermodel)
      await this.loadTrims()
      this.isLoaded = true
    },
    async updateFilterModel () {
      await this.updateFilter(this.filtermodel)
    },
    async resetFilterModel () {
      this.filtermodel.model = null
      this.filtermodel.make = null
      this.filtermodel.bodyType = null
      this.filtermodel.yearFrom = null
      this.filtermodel.yearTo = null
      this.filtermodel.priceTo = null
      this.filtermodel.priceFrom = null
      this.filtermodel.trim = null
      await this.updateFilterToDefault(this.filtermodel)
    },
    getYears () {
      let years = []
      let currentYear = new Date().getFullYear()
      let startYear = 2010

      while (startYear <= currentYear) {
        years.push(startYear++)
      }
      return years
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/src/mixins/dealertrend.filter.mixin.js